import API from 'services/api';

export const fiscalizationF1 = ({ invoiceId }: { invoiceId: string }) =>
  API.post(`/api/documents/invoices/${invoiceId}/fiscalization/f1`)?.then(
    response => response?.data,
  );
